import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export function downloadPDF() {
  const page = document.querySelector<HTMLElement>('#page-root')?.cloneNode(true);

  const copyContentHolder = document.querySelector<HTMLElement>('#copy-content');
  if (!copyContentHolder) {
    throw new Error('Could not find copy content holder');
  }
  copyContentHolder.innerHTML = '';

  copyContentHolder.appendChild(page!);

  html2canvas(copyContentHolder, { scale: 1.5 }) // ↓ lower scale from 2 → 1.5
    .then((canvas) => {
      copyContentHolder.innerHTML = '';
      // Convert canvas to JPEG with compression
      const imgData = canvas.toDataURL('image/jpeg', 0.75); // JPEG at 75% quality

      // PDF A4 width in mm
      const pdfWidth = 210;

      // Convert px → mm
      const pxToMm = 0.264583;
      const imgWidth = canvas.width * pxToMm;
      const imgHeight = canvas.height * pxToMm;

      // Scale height proportionally to fit A4 width
      const scaleFactor = pdfWidth / imgWidth;
      const scaledHeight = imgHeight * scaleFactor;

      // Create PDF with custom height
      const pdf = new jsPDF('p', 'mm', [pdfWidth, scaledHeight]);

      // Add the image as JPEG instead of PNG
      pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, scaledHeight);

      pdf.save('booking-confirmed.pdf');
    });
}
